<template>
  <l-layout>
    <v-card>
      <v-card-title style="height: 80px;">
        <span class="title pl-2">{{event.plate}}</span>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-container class="pt-0" fluid>
          <violation-info :event="event"></violation-info>
          <v-subheader>违章历史记录</v-subheader>
          <l-data-table
            class="mb-4"
            flat
            :headers="historyHeaders"
            :items="event.historyList || []"
            hide-title
            auto-actions
          ></l-data-table>
          <slot name="append"></slot>
        </v-container>
      </v-card-text>
    </v-card>
    <slot name="action"></slot>
  </l-layout>
</template>

<script>
import ViolationInfo from './violationInfo'
import imageMixin from './imageMixin'
import {time} from '../../../ladmin/utils'
import {VIOLATION_STATUS_TEXT} from '../../../object'

export default {
  name: 'violationDetailContent',
  components: {ViolationInfo},
  mixins: [imageMixin],
  props: {
    event: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    historyHeaders: [
      // {text: '车辆号牌', value: 'plate', align: 'left', placeholder: 'N/A'},
      // {text: '电话号码', value: 'phone', align: 'right', placeholder: 'N/A'},
      {text: '上报时间', value: 'creationTime', align: 'left', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '违章区域', value: 'area', align: 'right', placeholder: 'N/A'},
      {text: '违章类型', value: 'typeName', align: 'right', placeholder: 'N/A'},
      {text: '违章状态', value: 'status', align: 'right', placeholder: 'N/A', f: v => VIOLATION_STATUS_TEXT[v]}
    ],
    hasSearched: false
  }),
  computed: {
    hasVehicleInfo () {
      let owner = this.event.vehicle.owner || {}
      return owner.name || owner.phone
    }
  },
  methods: {
    initViolationInfo () {
      this.event.imageList.forEach(img => {
        if (img.isReady && !img.isError) {
          this.getImg(img)
        }
      })
    },
    async getViolationHistory () {
      let {items} = await this.$store.dispatch('violation/getEvents', {
        pagination: {page: 1, rowsPerPage: 500},
        search: {key: 'plate', value: this.event.plate}
      })
      let now = items.find(h => h.id === this.event.id)
      if (now) {
        this.historyHeaders[0].remark = {
          text: '本次违章',
          filter: (v, item) => {
            return item.id === now.id
          }
        }
      }
      this.$set(this.event, 'historyList', items)
    },
    async searchVehicle (v) {
      try {
        let {items, amount} = await this.$store.dispatch('pass/searchVehicles', {plate: v})
        // console.log(items, amount)
        if (amount) {
          this.event.vehicle = items[0]
        }
      }
      catch (e) {
        this.$L.error(e.message)
      }
      finally {
        this.hasSearched = true
      }
      // console.log(this.hasSearched, this.hasVehicleInfo)
    }
  },
  activated () {
    this.initViolationInfo()
    if (!this.event.historyList) {
      this.getViolationHistory()
    }
    if (!this.hasSearched) {
      this.searchVehicle(this.event.plate)
    }
  },
  created () {
    this.initViolationInfo()
    if (!this.event.historyList) {
      this.getViolationHistory()
    }
    if (!this.hasSearched) {
      this.searchVehicle(this.event.plate)
    }
  }
}
</script>

<style scoped>

</style>
